import { useEffect } from 'react'; // Import useEffect for the log
import BaseLayout from '../BaseLayout/BaseLayout';
import { useLanguage } from '../../../../../API/Context/LanguageContext';
import { vocabStatusPage } from '../../../../../ConfigFiles/multilingual/vocabStatusPage';

const StatusPage = ({ code = "404" }) => {
  const { lan } = useLanguage(); 
  const errorEntry = vocabStatusPage[code] || vocabStatusPage["default"];
  const content = errorEntry[lan] || errorEntry[0];

  useEffect(() => {
    const currentPath = window.location.pathname;
    
    // Log the error details for the developer
    console.group(`%c Status Page Diagnostic [${code}] `, 'background: #222; color: #bada55; padding: 2px;');
    console.log("Current Path:", currentPath);
    
    // Check specifically for the Render/Server "Redirect" bug
    if (currentPath.includes("index.html")) {
      console.warn("DIAGNOSTIC: The server is redirecting to /index.html. This is why the route isn't matching. Change Render 'Redirect' to 'Rewrite'.");
    }
    
    console.groupEnd();
  }, [code]);

  return (
    <BaseLayout>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '65vh',
        textAlign: 'center',
        padding: '2rem'
      }}>
        <h1 style={{ 
          fontSize: '7.5rem', 
          margin: '0', 
          color: 'var(--primary-color, #007bff)',
          fontWeight: '900'
        }}>
          {code}
        </h1>
        
        <h2 style={{ fontSize: '2rem', margin: '1rem 0', fontWeight: '700' }}>
          {content.title}
        </h2>
        
        <p style={{ maxWidth: '500px', marginBottom: '2.5rem', fontSize: '1.15rem', opacity: 0.8 }}>
          {content.message}
        </p>

        <button 
          onClick={() => window.location.href = '/'}
          style={{
            padding: '14px 35px',
            borderRadius: '12px',
            border: 'none',
            backgroundColor: 'var(--primary-color, #007bff)',
            color: 'white',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: '600',
          }}
        >
          {content.btn}
        </button>
      </div>
    </BaseLayout>
  );
};

export default StatusPage;